/* Nodi pre-order layer.
   Runs after bundle.js and does not modify it.
   Owns the product page buy box: button label, message, cart property,
   and which button is visible. */

(function () {
  var CFG = window.nodiPreorder || {};
  var PRE_LABEL = CFG.label || 'Pre-Order';
  var DEFAULT_LABEL = CFG.defaultLabel || 'Add to Cart';
  var CART_NOTE = CFG.cartNote || '';

  var actionsEl = document.querySelector('.product-main__actions');
  var lockedCustom = !!(actionsEl && actionsEl.classList.contains('product-main__actions--custom'));

  function setFirstText(el, txt) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim() !== '') {
        n.textContent = txt;
        return;
      }
    }
    el.insertBefore(document.createTextNode(txt), el.firstChild);
  }

  function collect() {
    var root = document.querySelector('.product-main');
    if (!root) return null;

    var msgs = root.querySelectorAll('.product-main__delivery');
    var std = null;
    for (var i = 0; i < msgs.length; i++) {
      if (!msgs[i].classList.contains('product-main__preorder-message')) {
        std = msgs[i];
        break;
      }
    }

    return {
      sizes: root.querySelector('.product-sizes'),
      atc: root.querySelector('.product-atc-form__atc-button'),
      atcText: root.querySelector('.product-atc-form__atc-button .button__text'),
      prop: root.querySelector('.product-atc-form__delivery-property'),
      bis: document.querySelector('.klaviyo-bis-trigger'),
      stdMsg: std,
      preMsg: root.querySelector('.product-main__preorder-message')
    };
  }

  function apply() {
    var e = collect();
    if (!e) return;

    var opt = e.sizes ? e.sizes.querySelector('.custom-select__option--selected') : null;
    var isPre = !!(opt && opt.getAttribute('data-preorder') === 'true');
    var avail = !!(opt && opt.getAttribute('data-available') === 'true');
    var isCustom = !!(opt && opt.getAttribute('data-custom') === 'true');
    var msg = (opt && opt.getAttribute('data-preorder-message')) || '';
    var note = (opt && opt.getAttribute('data-preorder-note')) || CART_NOTE;

    if (opt && actionsEl && !lockedCustom) {
      actionsEl.classList.toggle('product-main__actions--custom', isCustom);
    }

    if (e.preMsg) {
      if (isPre && msg) e.preMsg.textContent = msg;
      e.preMsg.classList.toggle('visually-hidden', !isPre);
    }
    if (isPre && e.stdMsg) e.stdMsg.classList.add('visually-hidden');

    if (e.atcText) setFirstText(e.atcText, isPre ? PRE_LABEL : DEFAULT_LABEL);

    if (opt && !isCustom) {
      if (e.atc) e.atc.style.display = avail ? 'flex' : 'none';
      if (e.bis) e.bis.style.display = avail ? 'none' : 'flex';
    }

    if (e.prop) {
      if (isPre) {
        e.prop.value = note;
        e.prop.disabled = false;
      } else {
        e.prop.value = '';
        e.prop.disabled = true;
      }
    }
  }

  function schedule() {
    setTimeout(apply, 0);
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('.product-sizes .custom-select__option')) schedule();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  var host = document.querySelector('.product-main__actions');
  if (host && window.MutationObserver) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 50);
    }).observe(host, { childList: true, subtree: true });
  }
})();